'use strict';

$(document).ready(function () {
    if ($(".json-how-to").length) {
        var dataJson = $(".json-how-to").attr("data-json");
        var dataTransformed = JSON.parse(dataJson);
        var sections = dataTransformed.sections;
    }
    var $menuTitles = $(".menu-titles");
    var htmlMenu = "";

    if (sections) {

        if (sections.length > 1) {
            for (var i=0; i<sections.length; i++) {
                var ariaSelected= i == 0 ? 'true' : 'false';
                var idpanel = sections[i].title + '-panel';
                var ariaLabelledby= sections[i].title + '-tab';
                htmlMenu = htmlMenu + "<div tabindex='-1' class='menu-title' role='tab' aria-selected=" + ariaSelected + " id="+ idpanel + " aria-labelledby="+ariaLabelledby +" >" + sections[i].title + "</div>";
            }
    
            $menuTitles.prepend(htmlMenu);
            $menuTitles.slick({
                slidesToShow: 5,
                centerPadding: '0',
                arrows: false,
                variableWidth: false,
                accessibility: false,
                swipe: true,
                initialSlide: 0,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            variableWidth: false,
                            initialSlide: 0,
                            arrows: true,
                            swipe: true,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.8,
                            initialSlide: 0,
                            centerPadding: '0',
                            arrows: false,
                            swipe: true,
                            infinite: false,
                            variableWidth: true,
                        },
                    },
                ],
            });
        } else {
            $menuTitles.hide();
        }
        var clickedSection = sections[0];
    
        if (clickedSection.videoUrl) {
            $(".video-iframe").attr("src", clickedSection.videoUrl);
            $("#how-to-video").show();
        } else {
            $("#how-to-video").hide();
        }
        // First element
        if (clickedSection.firstImageUrl) {
            $(".first-product-image-how-to").attr("src", clickedSection.firstImageUrl);
            $('.first-product-image-how-to').attr('alt', clickedSection.firstProductName);
            $(".first-product-image-how-to").css("visibility", "visible");
        } else {
            $(".first-product-image-how-to").css("visibility", "hidden");
        }
        if (clickedSection.firstText) {
            $(".first-text-element").html(clickedSection.firstText);
        }

        if (clickedSection.firstURL) {
            $('.first-redirection-url')
                .attr('href', clickedSection.firstURL)
                .attr('tabindex', '0')
                .attr('aria-hidden', false)
                .attr('aria-label', `This action will open the page ${clickedSection.firstProductName}`);
        }

        // Second element
        if (clickedSection.secondImageUrl) {
            $(".second-product-image-how-to").show();
            $(".second-product-image-how-to").css("visibility", "visible");
            $(".second-product-image-how-to").attr("src", clickedSection.secondImageUrl);
            $(".second-product-image-how-to").attr("alt", clickedSection.secondProductName);
        } else {
            $(".second-product-image-how-to").hide();
            $(".second-product-image-how-to").css("visibility", "hidden");
        }
        if (clickedSection.secondText) {
            $(".second-text-element").show();
            $(".second-text-element").html(clickedSection.secondText);
        } else {
            $(".second-text-element").hide();
            $('.second-redirection-url').attr('tabindex', '-1');
        }
        if (clickedSection.secondURL) {
            $('.second-redirection-url')
                .attr('href', clickedSection.secondURL)
                .attr('tabindex', '0')
                .attr('aria-hidden', false)
                .attr('aria-label', `This action will open the page ${clickedSection.secondProductName}`);
        }

        if (clickedSection.proTip && clickedSection.proTip.title && clickedSection.proTip.text) {
            $(".right-part").show();
            $(".pro-title").html(clickedSection.proTip.title);
            $(".pro-text").html(clickedSection.proTip.text);
        } else {
            $(".right-part").hide();
        }
        $(".menu-title").first().addClass("active-block").attr('tabindex', '0');
    }
    $(".menu-title").on('keydown',function(e){
        var key  = e.keyCode;
        if(key == 13 || key == 32){
            if ($(this).hasClass('slick-active')) {
                $(this).trigger('click');
            }
        } else if (key === 37) {
            e.preventDefault();
            $(this).prev().focus();
        } else if (key === 39) {
            e.preventDefault();
            $(this).next().focus();
        }
        
    });
    $menuTitles.on('click', '.menu-title', function(e) {
        e.stopPropagation();

        var currentIndex = $menuTitles.slick("slickCurrentSlide");
        var slideIndex = $(this).data("slick-index");

        $(".menu-title").removeClass("active-block");
        $(this).addClass("active-block");
        $menuTitles.find('.menu-title').attr('aria-selected', 'false').attr('tabindex', '-1');
        $(this).attr('aria-selected', 'true').attr('tabindex', '0');
        var title = $(this).text();
        var clickedSection;
        for (var i=0; i<sections.length; i++) {
            if (sections[i].title.toLowerCase() === title.toLowerCase()) {
                clickedSection = sections[i];
            }
        }

        if (clickedSection.videoUrl) {
            $(".video-iframe").attr("src", clickedSection.videoUrl);
            $("#how-to-video").show();
        } else {
            $("#how-to-video").hide();
        }
        // First element
        if (clickedSection.firstImageUrl) {
            $(".first-product-image-how-to").attr("src", clickedSection.firstImageUrl);
            $(".first-product-image-how-to").css("visibility", "visible");
        } else {
            $(".first-product-image-how-to").css("visibility", "hidden");
        }
        if (clickedSection.firstText) {
            $(".first-text-element").html(clickedSection.firstText);
        }
        if (clickedSection.firstURL) {
            $('.first-redirection-url')
                .attr('href', clickedSection.firstURL)
                .attr('tabindex', '0')
                .attr('aria-hidden', false)
                .attr('aria-label', `This action will open the page ${clickedSection.firstProductName}`);
        }

        // Second element
        if (clickedSection.secondImageUrl) {
            $(".second-product-image-how-to").show();
            $(".second-product-image-how-to").css("visibility", "visible");
            $(".second-product-image-how-to").attr("src", clickedSection.secondImageUrl);
        } else {
            $(".second-product-image-how-to").hide();
            $(".second-product-image-how-to").css("visibility", "hidden");
        }
        if (clickedSection.secondText) {
            $(".second-text-element").show();
            $(".second-text-element").html(clickedSection.secondText);
        } else {
            $(".second-text-element").hide();
            $('.second-redirection-url').attr('tabindex', '-1');
        }
        if (clickedSection.secondURL) {
            $('.second-redirection-url')
                .attr('href', clickedSection.secondURL)
                .attr('tabindex', '0')
                .attr('aria-hidden', false)
                .attr('aria-label', `This action will open the page ${clickedSection.secondProductName}`);
        }

        if (clickedSection.proTip && clickedSection.proTip.title && clickedSection.proTip.text) {
            $(".right-part").show();
            $(".pro-title").html(clickedSection.proTip.title);
            $(".pro-text").html(clickedSection.proTip.text);
        } else {
            $(".right-part").hide();
        }
        $('#howto-title')[0].scrollIntoView({ behavior: 'instant', block: 'center' });
        if(currentIndex == slideIndex) {
            return;
        }
        else if(currentIndex - 1 == slideIndex) {
            $menuTitles.slick("slickPrev");
        }
        else if(currentIndex + 1 == slideIndex) {
            $menuTitles.slick("slickNext");
        }
        else if(currentIndex == 0) {
            $menuTitles.slick("slickPrev");
        }
        else {
            $menuTitles.slick("slickNext");
        }
    });
});